import { create } from 'zustand';
import { persist } from 'zustand/middleware';

var d=create(persist(o=>({connectedConnectorId:"",setConnectedConnectorId(e){o({connectedConnectorId:e});}}),{name:"crossbell/connect-kit/connector-store"}));

export { d as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-EDSSKNZQ.mjs.map